import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentCompany: null,
  companies: [],
  loading: false,
  error: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCurrentCompany: (state, action) => {
      state.currentCompany = action.payload;
    },
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
  },
});

export const { setCurrentCompany, setCompanies } = companySlice.actions;
export default companySlice.reducer;
